import { FormField } from '@/components/ui/form';
import { genericMemo } from '@/types/use';
import * as React from 'react';
import { Path, PathValue, useFormContext } from 'react-hook-form';
import { FormFieldsValues, RenderFieldItemProps } from './form-types';

/**1 là truyền render không cần truyền children, 2 là truyền children không cần truyền render */
type ConditionProps<T extends FormFieldsValues> =
    | {
          render: (props: RenderFieldItemProps<T>) => React.ReactElement;
          children?: never;
      }
    | {
          render?: never;
          children:
              | React.ReactNode
              | ((props: RenderFieldItemProps<T>) => React.ReactElement);
      };
type ControllerProps<T extends FormFieldsValues> = {
    name: Path<T>;
    defaultValue?: PathValue<T, Path<T>>;
    disabled?: boolean;
    shouldUnregister?: boolean;
};

type Props<T extends FormFieldsValues> = ControllerProps<T> & ConditionProps<T>;

const CustomFormItem = <T extends FormFieldsValues = any>(props: Props<T>) => {
    const { children, render, ...rest } = props;

    const _customRender = React.useCallback(
        ({ field, fieldState, formState }: RenderFieldItemProps<T>) => {
            if (typeof children === 'function') {
                return children({ field, fieldState, formState });
            }
            // default
            let clonedItem = React.isValidElement(children)
                ? React.cloneElement(children, field)
                : null;

            return <>{clonedItem}</>;
        },
        [children]
    );

    return (
        <FormField
            {...rest}
            render={typeof render === 'function' ? render : _customRender}
        />
    );
};

export default genericMemo(CustomFormItem);
